import React, { useRef, useState, useEffect  }  from "react";
import { Link } from "react-router-dom";
import "./Selectedprojects.css";
import useInView from '../useInView';
import { useNavigate } from "react-router-dom";
import { getSelectedProjects } from './Api'; // Import the API function



const Selectedprojects = () => {
    const ref = useRef(null); // Ref to the section element
    const isInView = useInView({ threshold: 0.18 });
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);

    useEffect(() => {
      const fetchProjects = async () => {
        try {
          console.log("Fetching projects...");
          const Selectedprojects = await getSelectedProjects();
          console.log("API Response:", Selectedprojects.data);
          if(Array.isArray(Selectedprojects.data)){
            setProjects([...Selectedprojects.data]);
          }
        } catch (error) {
          console.error("Error fetching projects:", error);
        }
      };
      fetchProjects();
    }, []);
  


  const handleProjectClick = (id) => {
    // Navigate to the single project page
    navigate(`/projects/${id}`);
  };
    
  return (
    <section ref={ref} className={`selected-projects fade-in-up ${isInView ? 'visible' : ''}`} >
        <div className="project-head">
        <h2 className="section-title">Selected projects</h2>
        <Link to="/projects" className="custom-link" class="see-all-button">View all projects</Link>
        <Link to="/projects" className="custom-link" class="see-all-button-mobile">View all</Link>
        </div>
      <div className="projects-grid">
      {projects.map((project) => (
          <div className="project-card" key={project.id} onClick={() => handleProjectClick(project.id)}>
          <img 
            src={project.cover_photo || '/path/to/fallback-image.jpg'} 
            alt={project.name} 
            className="project-image" 
          />
            <div className="project-overlay">
              <h3 className="project-name">{project.name}</h3>
              <div className="tags">
              {project.tags && Array.isArray(project.tags) && project.tags.map(tag => (
              <p key={tag.id} className="project-tags">{tag.name}</p>
            ))} </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Selectedprojects;
